// extracted by mini-css-extract-plugin
module.exports = {"flag":"region-selector-button_flag__8jCtZ"};